import { observable, action, computed } from 'mobx';
import agent from '../agent';
import React, { Component } from 'react';
import Images from '../Theme/Images';
import { ReactSVG } from 'react-svg'
import CircularProgress from '@material-ui/core/CircularProgress';
import commonStore from './commonStore';
import constants from '../constants';
import userStore from './userStore';
import dashboardStore from './dashboardStore';
import imageStore from './imageStore';

export class DocumentStore {
    @observable inProgress = false;
    @observable statusText;
    @observable errors;
    @observable currentPage = {}
    @observable openDrawer = false;
    @observable currentTopValue = 0;
    @observable currentDoc = {};
    @observable updatedValues = []
    @observable updateProgress = false;
    @observable currentField = { style: { height: '0px', width: '0px', display: 'none', top: '0px', left: '0px' } }
    @observable currentIndex = 0;
    @observable updatedTabularFields = []
    @observable updatedNonTabularFields = []
    @observable tableHeaders = []
    @observable financeDocs = ['PO', 'MEDIASSIST', 'NEW_INVOICE', 'WRITERCORP', 'HAND_WRITTEN', 'RENT_AGREEMENT']
    @observable disableCropping = ['HAND_WRITTEN']

    @action updateField(value, index, fieldId, type) {
        this.currentPage.formData[index].editedValue = value;
        let temp = {};
        temp.fieldId = fieldId;
        temp.fieldValue = value;
        let currentIndex = this.updatedValues.findIndex(x => x.fieldId == fieldId)
        if (currentIndex !== -1)
            this.updatedValues[currentIndex] = temp
        else
            this.updatedValues.push(temp);
    }

    @action updatePosoField(value, index, fieldId, coordinates) {
        if (this.currentField.page !== undefined)
            this.updateNonTabularField(value, index, fieldId, coordinates)
        else
            this.updateTabularField(value, index, fieldId, coordinates)
    }

    @action updateNonTabularField(value, index, fieldId, coordinates) {
        this.currentDoc.nonTabularData[index].editedValue = value;
        if (coordinates !== undefined)
            this.currentDoc.nonTabularData[index].pts = coordinates
        this.currentField.editedValue = value
        let temp = {};
        temp.fieldId = fieldId;
        temp.fieldValue = value;
        if (coordinates !== undefined)
            temp.pts = coordinates
        let currentIndex = this.updatedNonTabularFields.findIndex(x => x.fieldId == fieldId)
        if (currentIndex !== -1)
            this.updatedNonTabularFields[currentIndex] = temp
        else
            this.updatedNonTabularFields.push(temp);
    }

    @action updateTabularField(value, index, fieldId, coordinates) {
        this.currentPage.tableData[index].editedValue = value;
        let temp = {};
        temp.fieldId = fieldId;
        temp.fieldValue = value;
        temp.pageId = this.currentPage._id
        if (coordinates !== undefined)
            temp.pts = coordinates
        this.currentField.editedValue = value
        let currentIndex = this.updatedTabularFields.findIndex(x => x.fieldId == fieldId)
        if (currentIndex !== -1)
            this.updatedTabularFields[currentIndex] = temp
        else
            this.updatedTabularFields.push(temp);
    }

    @action updateSnippedField(value, newCoordinates) {
        this.currentField.editedValue = value;
        let temp = {};
        temp.fieldId = this.currentField._id;
        temp.fieldValue = value;
        temp.pts = newCoordinates;
        let indexInPage = this.currentPage.formData.findIndex(x => x._id == this.currentField._id)
        if (indexInPage !== -1)
            this.currentPage.formData[indexInPage].pts = newCoordinates;
        let currentIndex = this.updatedValues.findIndex(x => x.fieldId == this.currentField._id)
        if (currentIndex !== -1)
            this.updatedValues[currentIndex] = temp
        else
            this.updatedValues.push(temp);
    }

    @action updateSnippedFieldPoso(value, newCoordinates) {
        this.currentField.editedValue = value;
        if (this.currentField.page !== undefined) {
            let index = -1;
            index = this.currentDoc.nonTabularData.findIndex(x => x._id == this.currentField._id)
            this.updateNonTabularField(value, index, this.currentField._id, newCoordinates)
        }

        else {
            let index = -1;
            let pageIndex = -1;
            pageIndex = this.currentDoc.pageArray.findIndex(x => x._id == this.currentPage._id)
            if (pageIndex > -1)
                index = this.currentDoc.pageArray[pageIndex].tableData.findIndex(x => x._id == this.currentField._id)
            this.currentDoc.pageArray[pageIndex].tableData[index].pts = newCoordinates
            console.log(this.currentDoc.pageArray[pageIndex].tableData[index], 'mine')
            this.updateTabularField(value, index, this.currentField._id, newCoordinates)
        }
    }

    @action resetCurrentField() {
        this.currentField = { style: { height: '0px', width: '0px', display: 'none', top: '0px', left: '0px' } };
        imageStore.eraseDrawPoint();
    }

    @action undoChanges(index) {
        this.currentPage.formData[index].editedValue = this.currentPage.formData[index].aiValue;
        this.currentField.editedValue = this.currentPage.formData[index].aiValue;
        let i = this.updatedValues.findIndex(x => x.fieldId === this.currentField._id);
        if (i > -1)
            this.updatedValues.splice(i, 1);
    }

    @action undoPosoChanges() {
        let index = -1
        if (this.currentField.page !== undefined) {
            index = this.currentDoc.nonTabularData.findIndex(x => x._id == this.currentField._id)
            if (index > -1) {
                this.currentField.editedValue = this.currentField.aiValue;
                this.currentField.pts = this.currentField.tempPts
                this.currentDoc.nonTabularData[index].editedValue = this.currentField.aiValue;
                this.currentDoc.nonTabularData[index].pts = this.currentField.tempPts
                let i = this.updatedNonTabularFields.findIndex(x => x.fieldId === this.currentField._id);
                if (i > -1)
                    this.updatedNonTabularFields.splice(i, 1);
            }
        }
        else {
            let pageIndex = this.currentDoc.pageArray.findIndex(x => x._id == this.currentPage._id)
            index = this.currentDoc.pageArray[pageIndex].tableData.findIndex(x => x._id == this.currentField._id)
            if (index > -1) {
                this.currentField.editedValue = this.currentField.aiValue;
                console.log(this.currentField, 'hey')
                this.currentField.pts = this.currentField.tempPts
                this.currentDoc.pageArray[pageIndex].tableData[index].editedValue = this.currentField.aiValue;
                this.currentDoc.pageArray[pageIndex].tableData[index].pts = this.currentField.pts
                let i = this.updatedTabularFields.findIndex(x => x.fieldId === this.currentField._id);
                if (i > -1)
                    this.updatedTabularFields.splice(i, 1);
            }
        }
    }

    @action setCurrentField(item, index) {
        this.currentField = item;
        this.currentField.style = { height: '0px', width: '0px' };
        this.currentIndex = index;
    }

    @action editCurrentFieldValue(text) {
        console.log(text, 'hii', this.currentField)
        this.currentField.editedValue = text;
        //this.updateDocument(false,true)
    }

    @action setPosition(top, left) {
        this.currentField.style.top = top;
        this.currentField.style.left = left;
    }

    @action setCurrentTopValue() {
        this.currentTopValue = this.currentField.style.top
    }

    @action moveTopPosition(top) {
        this.currentField.style.top = parseInt(this.currentTopValue) + parseInt(top) + 'px';
    }

    @action setFieldMeasure(h, w, display) {
        this.currentField.style = { height: h, width: w, display: display }
    }

    @action setCurrentImage(currentPage, pageNo) {
        this.currentPage = currentPage;
        this.currentPage.formData.forEach(function (v) {
            if (v.editedValue && v.editedValue.length)
                v.aiValue = v.editedValue;
        });
        this.resetCurrentField()
    }

    @action setCurrentPage(index) {
        this.currentPage = this.currentDoc.pageArray[index]
    }

    @action setCurrentImagePoSo(currentPage, pageNo) {
        this.currentPage = currentPage;
        this.currentDoc.nonTabularData.forEach(function (v) {
            if (v.editedValue && v.editedValue.length)
                v.aiValue = v.editedValue;
        });
        this.resetCurrentField()
    }

    @action openDocumentDrawer() {
        this.openDrawer = true;
    }

    @action closeDocumentDrawer() {
        this.openDrawer = false;
    }

    @action setupUpdatePayload(finalSubmit) {
        let payload = {};
        for (let i = 0; i < this.currentPage.formData.length; i++) {
            for (let j = 0; j < this.updatedValues.length; j++) {
                if (this.currentPage.formData[i]._id == this.updatedValues[j].fieldId) {
                    this.currentPage.formData[i].updateProgress = true
                    this.currentPage.formData[i].progressIcon = <CircularProgress size={30} thickness={5} />
                }
            }
        }
        payload.fieldArray = this.updatedValues;
        payload.documentId = this.currentDoc._id;
        payload.finalFlag = finalSubmit;
        payload.pageId = this.currentPage._id;
        return payload;
    }

    @action setProgressIcon(index) {
        this.currentPage.formData[index].progressIcon = <ReactSVG src="" />
    }

    @action updateForm() {
        let payload = this.setupUpdatePayload(false);
        let currentIndex = this.currentDoc.pageArray.findIndex(x => x._id == this.currentPage._id)
        return agent.Documents.updateDocument(payload)
            .then(action((response) => {
                this.updateProgress = false;
                if (response.statusCode == "200") {
                    this.currentPage.formData.forEach(function (v) {
                        if (v.editedValue.length)
                            v.aiValue = v.editedValue;
                    });
                    for (let i = 0; i < this.currentDoc.pageArray[currentIndex].formData.length; i++) {
                        for (let j = 0; j < this.updatedValues.length; j++) {
                            if (this.currentDoc.pageArray[currentIndex].formData[i]._id == this.updatedValues[j].fieldId) {
                                this.currentDoc.pageArray[currentIndex].formData[i].progressIcon = <ReactSVG src={Images['fieldRight']} />
                                setTimeout(() => { this.setProgressIcon(i) }, 3000)
                            }
                        }
                    }
                    this.updatedValues = []
                }

            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                //this.inProgress = false;
            }))
    }



    @action updateDocument(finalSubmit, next) {
        let currentIndex = this.currentDoc.pageArray.findIndex(x => x._id == this.currentPage._id)
        this.statusText = '';
        this.errors = undefined;
        if (finalSubmit)
            this.updateProgress = true;
        if (this.updatedValues.length == 0) {
            if (!finalSubmit && !next)
                return;
        }

        let payload = this.setupUpdatePayload(finalSubmit);
        if (next) {
            if (currentIndex > -1)
                this.setCurrentImage(this.currentDoc.pageArray[currentIndex + 1], currentIndex + 1)
        }
        return agent.Documents.updateDocument(payload)
            .then(action((response) => {
                this.updateProgress = false;
                if (response.statusCode == "200") {
                    if (finalSubmit)
                        this.currentDoc.pageArray[currentIndex].reviewed = true
                    for (let i = 0; i < this.currentDoc.pageArray[currentIndex].formData.length; i++) {
                        for (let j = 0; j < this.updatedValues.length; j++) {
                            if (this.currentDoc.pageArray[currentIndex].formData[i]._id == this.updatedValues[j].fieldId) {
                                this.currentDoc.pageArray[currentIndex].formData[i].progressIcon = <ReactSVG src={Images['fieldRight']} />
                                setTimeout(() => { this.setProgressIcon(i) }, 3000)
                            }
                        }
                    }
                    this.updatedValues = [];
                    if (finalSubmit)
                        commonStore.handleOpenSnackBar("Document updated successfully!", 'success')
                }
                else {
                    commonStore.handleOpenSnackBar(response.message, 'error')
                }


            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                //this.inProgress = false;
            }))
    }

    @action setupUpdatePosoPayload(type) {
        let payload = {};
        if (this.updatedTabularFields.length) {
            this.currentDoc.pageArray.map((page, pageIndex) => {
                for (let i = 0; i < page.tableData.length; i++) {
                    for (let j = 0; j < this.updatedTabularFields.length; j++) {
                        if (page.tableData[i]._id == this.updatedTabularFields[j].fieldId) {
                            page.tableData[i].updateProgress = true;
                            if (type === 'right') {
                                page.tableData[i].progressIcon = <ReactSVG src={Images['fieldRight']} />
                            }
                            else if (type === 'end')
                                page.tableData[i].progressIcon = <ReactSVG src='' />
                            else
                                page.tableData[i].progressIcon = <CircularProgress size={30} thickness={5} />
                        }
                    }
                }
            })
        }
        if (this.updatedNonTabularFields.length) {
            for (let i = 0; i < this.currentDoc.nonTabularData.length; i++) {
                for (let j = 0; j < this.updatedNonTabularFields.length; j++) {
                    if (this.currentDoc.nonTabularData[i]._id == this.updatedNonTabularFields[j].fieldId) {
                        this.currentDoc.nonTabularData[i].updateProgress = true
                        if (type === 'right')
                            this.currentDoc.nonTabularData[i].progressIcon = <ReactSVG src={Images['fieldRight']} />
                        else if (type === 'end')
                            this.currentDoc.nonTabularData[i].progressIcon = <ReactSVG src='' />
                        else
                            this.currentDoc.nonTabularData[i].progressIcon = <CircularProgress size={30} thickness={5} />
                    }
                }
            }
        }

        payload.tabularDataArray = this.updatedTabularFields;
        payload.nonTabularDataArray = this.updatedNonTabularFields
        payload.documentId = this.currentDoc._id;
        payload.finalFlag = true;
        return payload;
    }

    @action setupPayloadForPosoField(field) {
        let payload = {}
        if (field.page !== undefined) {
            let obj = { fieldId: field._id, fieldValue: field.editedValue, pts: field.pts }
            let temp = []
            temp.push(obj)
            let index = this.updatedNonTabularFields.findIndex(x => x.fieldId == field._id)
            if (index > -1)
                this.updatedNonTabularFields.splice(index, 1)
            payload.nonTabularDataArray = temp;
            payload.tabularDataArray = [];
            payload.documentId = this.currentDoc._id;
            payload.finalFlag = false;
            return payload;
        }
        else {
            let obj = { fieldId: field._id, fieldValue: field.editedValue, pts: field.pts, pageId: this.currentPage._id }
            let temp = []
            temp.push(obj)
            let index = this.updatedTabularFields.findIndex(x => x.fieldId == field._id)
            if (index > -1)
                this.updatedTabularFields.splice(index, 1)
            payload.nonTabularDataArray = [];
            payload.tabularDataArray = temp;
            payload.documentId = this.currentDoc._id;
            payload.finalFlag = false;
            return payload;
        }
    }

    @action setProgressIconPoso(field) {
        this.setupUpdatePosoPayload('end')
        if (field === undefined) {
            this.updatedNonTabularFields = [];
            this.updatedTabularFields = [];
        }
    }

    @action updatePosoDocument(field, autoSave) {
        let currentIndex = this.currentDoc.pageArray.findIndex(x => x._id == this.currentPage._id)
        this.statusText = '';
        this.errors = undefined;
        if (!autoSave || autoSave === undefined)
            this.updateProgress = true;
        let payload = {}
        if (field !== undefined)
            payload = this.setupPayloadForPosoField(field)
        else
            payload = this.setupUpdatePosoPayload();
        return agent.Documents.updatePoSoDocument(payload)
            .then(action((response) => {
                this.updateProgress = false;
                if (response.statusCode == "200") {
                    this.setupUpdatePosoPayload('right')
                    setTimeout(() => { this.setProgressIconPoso(field) }, 3000)
                    commonStore.handleOpenSnackBar("Document updated successfully!", 'success')
                }
                else {
                    commonStore.handleOpenSnackBar(response.message, 'error')
                    this.setupUpdatePosoPayload('end')
                }


            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.updateProgress = false
            }))
    }

    @action headerDisplayed(header) {
        this.tableHeaders.push(header)
        var set = new Set(this.tableHeaders);
        this.tableHeaders = Array.from(set);
    }


    @action updateMediassistDocument(field, autoSave) {
        let currentIndex = this.currentDoc.pageArray.findIndex(x => x._id == this.currentPage._id)
        this.statusText = '';
        this.errors = undefined;
        if (!autoSave || autoSave === undefined)
            this.updateProgress = true;
        let payload = {}
        if (field !== undefined)
            payload = this.setupPayloadForPosoField(field)
        else
            payload = this.setupUpdatePosoPayload();
        delete payload.tabularDataArray
        return agent.Documents.updateMediassistDocument(payload)
            .then(action((response) => {
                this.updateProgress = false;
                if (response.statusCode == "200") {
                    this.setupUpdatePosoPayload('right')
                    setTimeout(() => { this.setProgressIconPoso(field) }, 3000)
                    commonStore.handleOpenSnackBar("Document updated successfully!", 'success')
                }
                else {
                    commonStore.handleOpenSnackBar(response.message, 'error')
                    this.setupUpdatePosoPayload('end')
                }


            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.updateProgress = false
            }))
    }

    @action updateWritercorpDocument(field, autoSave) {
        let currentIndex = this.currentDoc.pageArray.findIndex(x => x._id == this.currentPage._id)
        this.statusText = '';
        this.errors = undefined;
        if (!autoSave || autoSave === undefined)
            this.updateProgress = true;
        let payload = {}
        if (field !== undefined)
            payload = this.setupPayloadForPosoField(field)
        else
            payload = this.setupUpdatePosoPayload();

        return agent.Documents.updateWritercorpDocument(payload)
            .then(action((response) => {
                this.updateProgress = false;
                if (response.statusCode == "200") {
                    this.setupUpdatePosoPayload('right')
                    setTimeout(() => { this.setProgressIconPoso(field) }, 3000)
                    commonStore.handleOpenSnackBar("Document updated successfully!", 'success')
                }
                else {
                    commonStore.handleOpenSnackBar(response.message, 'error')
                    this.setupUpdatePosoPayload('end')
                }


            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.updateProgress = false
            }))
    }


    @action setProgress() {
        this.inProgress = true
    }

    @action getDocumentDetails(docId) {
        this.statusText = '';
        this.errors = undefined;
        this.inProgress = true;
        return agent.Dashboard.getDocumentDetails(docId)
            .then(action((response) => {
                if (response.statusCode == '200') {
                    this.currentDoc = response.documentDetails;
                    this.currentPage = this.currentDoc.pageArray[0];
                    if (this.financeDocs.findIndex(x => x === this.currentDoc.docType) === -1) {
                        if (this.currentPage.formData.length) {
                            this.currentIndex = 0;
                            this.currentPage.formData.forEach(function (v) {
                                v.tempPts = v.pts;
                                if (v.editedValue.length)
                                    v.aiValue = v.editedValue;
                            });
                            this.resetCurrentField();
                        }
                    }

                    else {
                        if (this.currentDoc.nonTabularData.length) {
                            this.currentIndex = 0;
                            this.currentDoc.nonTabularData.forEach(function (v) {
                                v.tempPts = v.pts;
                                if (v.editedValue && v.editedValue.length)
                                    v.aiValue = v.editedValue;
                                else if (v.aiValue === null)
                                    v.aiValue = ''
                            });
                            this.resetCurrentField();
                        }
                        this.currentDoc.pageArray.map((page, pageIndex) => {
                            if (page.tableData.length) {
                                this.currentIndex = 0;
                                page.tableData.forEach(function (v) {
                                    v.tempPts = v.pts;
                                    if (v.editedValue && v.editedValue.length)
                                        v.aiValue = v.editedValue;
                                    else if (v.aiValue === null)
                                        v.aiValue = ''
                                });

                            }
                        })
                        this.resetCurrentField();
                    }


                }
            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.inProgress = false;
            }))
    }
}

export default new DocumentStore();
